import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NbEvaIconsModule } from "@nebular/eva-icons";
import { NbThemeModule, NbMenuModule, NbLayoutModule, NbActionsModule, NbContextMenuModule, NbCardModule, NbIconModule, NbSidebarModule, NbTabsetModule, NbSpinnerModule, NbDatepickerModule, NB_TIME_PICKER_CONFIG, NbDialogModule } from "@nebular/theme";
import { NTXCoreModule } from "./modules/ntx-core/ntx-core.module";
import { PageModule } from "./modules/ntx-page/page.module";
import { SharedModule } from "src/app/shared/shared.module";
import { LayoutModule } from "./components/ngx-components/layout/layout.module";
import { TablesModule } from "./components/ngx-components/tables/tables.module";
import { NTXChartsModule } from "./modules/ntx-charts/ntx-charts.module";

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    NbMenuModule.forRoot(),
    NbLayoutModule,
    NbSpinnerModule,
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    PageModule
  ],
  exports: [
    NTXCoreModule,
    PageModule,
    NbLayoutModule,
    NbActionsModule,
    NbContextMenuModule,
    NbCardModule,
    NbIconModule,
    NbSidebarModule,
    NbEvaIconsModule,
    NbTabsetModule,
    NbThemeModule,
    NbMenuModule,
    NbSpinnerModule,
    NTXChartsModule,
    TablesModule,
    LayoutModule
  ],
  providers:[{
    provide: NB_TIME_PICKER_CONFIG,
    useValue: {},
  }]
})
export class NTXAppModule { }
